import React, { useContext } from "react";
import { RESOURCE_NAME } from "common/authorization";
import { track } from "../../utils/tracking";
import { AuthContext } from "../Authorization/AuthContext";
import { ActionCellContainer } from "../Common/__styles__/ActionCell";
import { Button } from "../Common/Button";
import { CRS_310_REPORT, EC_REPORT } from "../Exports/constants";
import ExportDataButton from "../Exports/ExportDataButton";
import { QueryFileTableResult } from "./__queries__/table";
import ActionButton from "./ActionButton";
import { useUploadDocumentsFormModal } from "./ElevationCertificates/hooks";
import { DocumentUploadsTable } from "./FilesTable";

const ActionCellDef = ({
  original,
  onUpdate,
}: {
  original: QueryFileTableResult;
  onUpdate: () => {};
}) => {
  return (
    <ActionCellContainer>
      <ActionButton
        isDetailView={false}
        onUpdate={onUpdate}
        documentUpload={original}
      />
    </ActionCellContainer>
  );
};

export const ListDocumentUploads = () => {
  const { authorized, supportsElevationCertificates } = useContext(AuthContext);
  const [showUploadModal] = useUploadDocumentsFormModal();

  const canAddCertificates = authorized({
    resource: RESOURCE_NAME.DOCUMENT_UPLOAD,
    permission: "create",
  });

  const onClickUpload = () => {
    track("Clicked upload from EC List");
    showUploadModal();
  };

  const initialReportTypes =
    supportsElevationCertificates ? [EC_REPORT, CRS_310_REPORT] : [];

  const actions = (
    <>
      <ExportDataButton initialReportTypes={initialReportTypes} />
      {supportsElevationCertificates && (
        <Button
          onClick={onClickUpload}
          size="small"
          styleVariant="primary"
          disabled={!canAddCertificates}
          aria-label="Upload Elevation Certificates"
          leftIconName="plus"
        >
          Upload Elevation Certificates
        </Button>
      )}
    </>
  );

  return (
    <DocumentUploadsTable tableActions={actions} actionCell={ActionCellDef} />
  );
};
